import { createContext, useContext } from "react";
import CommonStore from "./commonStore";
import ModalStore from "./modalStore";
import PlayerProfileStore from "./playerProfileStore";
import UserStore from "./userStore";
import AppDataStore from './appDataStore';
import AdminStore from "./adminStore";
import BasicUserStore from "./basicUserStore";
import AdminCollectionStore from "./adminCollectionStore";
// import ReprtingStore from "./reportingStore";
import ReportingStore from "./reportingStore";
import PartnerStore from "./partnerStore";

interface Store {
    commonStore: CommonStore;
    userStore: UserStore;
    modalStore: ModalStore;
    playerProfileStore: PlayerProfileStore;
    appDataStore: AppDataStore;
    adminStore: AdminStore;
    adminCollectionStore: AdminCollectionStore;
    basicUserStore: BasicUserStore;
    reportingStore: ReportingStore;
    partnerStore: PartnerStore;
}

export const store: Store = {
    commonStore: new CommonStore(),
    userStore: new UserStore(),
    modalStore: new ModalStore(),
    playerProfileStore: new PlayerProfileStore(),
    appDataStore: new AppDataStore(),
    adminStore: new AdminStore(),
    adminCollectionStore: new AdminCollectionStore(),
    basicUserStore: new BasicUserStore(),
    reportingStore: new ReportingStore(),
    partnerStore: new PartnerStore()
}

export const StoreContext = createContext(store);

export function useStore() {
    return useContext(StoreContext);
}